import React from 'react';
import { cn } from '../../../utils/cn';

const SyringeSelector = ({ value, onChange }) => {
  const options = [
    { value: 30, label: '30 units' },
    { value: 50, label: '50 units' },
    { value: 100, label: '100 units' }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {options?.map((option) => (
        <button
          key={option?.value}
          onClick={() => onChange(option?.value)}
          className={cn(
            "p-4 rounded-lg border-2 transition-all duration-200",
            value === option?.value
              ? "border-primary bg-primary/10 shadow-[0_0_20px_rgba(0,212,255,0.3)]"
              : "border-border hover:border-primary/50 bg-card"
          )}
        >
          <div className="flex items-center justify-center gap-3">
            <div
              className={cn(
                "w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all",
                value === option?.value
                  ? "border-primary bg-primary" :"border-muted-foreground"
              )}
            >
              {value === option?.value && (
                <div className="w-2 h-2 rounded-full bg-background" />
              )}
            </div>
            <span className={cn(
              "text-lg font-semibold",
              value === option?.value ? "text-primary" : "text-foreground"
            )}>
              {option?.label}
            </span>
          </div>
        </button>
      ))}
    </div>
  );
};

export default SyringeSelector;